import { render, staticRenderFns } from "./stack.vue?vue&type=template&id=323439f4&scoped=true&lang=pug&"
import script from "./stack.vue?vue&type=script&lang=js&"
export * from "./stack.vue?vue&type=script&lang=js&"
import style0 from "./stack.vue?vue&type=style&index=0&id=323439f4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323439f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('323439f4', component.options)
    } else {
      api.reload('323439f4', component.options)
    }
    module.hot.accept("./stack.vue?vue&type=template&id=323439f4&scoped=true&lang=pug&", function () {
      api.rerender('323439f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form_element/position/align/stack.vue"
export default component.exports